import { render, staticRenderFns } from "./WidgetActivities.vue?vue&type=template&id=954ae6a4&scoped=true&"
import script from "./WidgetActivities.vue?vue&type=script&lang=ts&"
export * from "./WidgetActivities.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetActivities.vue?vue&type=style&index=0&id=954ae6a4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954ae6a4",
  null
  
)

export default component.exports